import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import RecordedQuestionsTable from './RecordedQuestionsTable';
const RecordedQuestions = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Recorded Questions' parent='Recorded Questions'  />
      <Container fluid={true}>
        <Row>
          <RecordedQuestionsTable  />
        </Row>
      </Container>
    </Fragment>
  );
};

export default RecordedQuestions;
